import { all } from 'redux-saga/effects';
import { omit } from 'lodash';
import * as CarrierWatchers from './carrierSaga';
import * as PropertyWatchers from './propertySaga';
import * as ConfigurationWatchers from './configurationSaga';
import * as PackageWatchers from './packageSaga';
import * as TemplateWatchers from './templateSaga';
import * as CostWatchers from './costSaga';
import loadHistoryWatcher from './historySaga';
import * as UserWatchers from './userSaga';
import * as LayoutWatchers from './layoutSaga';
import * as PartnerWatchers from './partnerSaga';
import * as ResellerWatchers from './resellerSaga';
import * as SegmentWatchers from './segmentSaga';
import * as ProductGroupWatchers from './productGroupSaga';
import * as DiscountWatchers from './discountSaga';
import * as PromotionWatchers from './promotionSaga';
import * as TranslationWatchers from './translationSaga';
import * as ImportWatchers from './importSaga';
import * as CustomerWatchers from './customerSaga';
import * as OrderWatchers from './orderSaga';
import * as QuoteWatchers from './quoteSaga';
import * as FormWatchers from './formSaga';
import * as JobResultWatchers from './jobResultSaga';
import * as PackagingWatchers from './packagingSaga';
import * as RollsInWatchers from './rollInSaga';
import * as RollsOutWatchers from './rollOutSaga';
import * as FormVersionWatchers from './formVersionSaga';
import * as PlanningWatchers from './planningSaga';
import * as MachineWatchers from './machineSaga';
import * as JobWatchers from './jobSaga';
import * as CoatingInWatchers from './coatingInSaga';
import * as CoatingOutWatchers from './coatingOutSaga';
import * as ReprintWatchers from './reprintSaga';
import * as ErrorsWatchers from './errorsSaga';
import * as OrderItemWatchers from './orderItemSaga';
import * as DesignLibraryWatchers from './designLibrarySaga';
import * as LogisticWatchers from './logisticSaga';
import * as BoxWatchers from './boxSaga';
import * as EmailTemplateWatchers from './emailTemplateSaga';
import * as shippingTypeWatchers from './shippingTypeSaga';
import * as paymentTypeWatchers from './paymentTypeSaga';
import * as storeWatchers from './storeSaga';
import * as accountancyWatchers from './accountancySaga';
import * as statisticsWatchers from './statisticSaga';

function effects(watchers) {
    return Object.keys(watchers).map(w => watchers[w]());
}

export default function* rootSaga() {
    yield all([
        // C A R R I E R S
        ...effects(CarrierWatchers),
        // C A R R I E R S

        // P R O P E R T I E S   &   V A L U E S
        ...effects(PropertyWatchers),
        // P R O P E R T I E S   &   V A L U E S

        // C O N F I G U R A T I O N S
        ...effects(ConfigurationWatchers),
        // C O N F I G U R A T I O N S

        // P A C K A G E S
        ...effects(PackageWatchers),
        // P A C K A G E S

        // T E M P L A T E S
        ...effects(TemplateWatchers),
        // T E M P L A T E S

        // C O S T S
        ...effects(CostWatchers),
        // C O S T S

        // H I S T O R Y
        loadHistoryWatcher(),
        // H I S T O R Y

        // U S E R S   &   U S E R G R O U P S
        ...effects(UserWatchers),
        // U S E R S   &   U S E R G R O U P S

        // L A Y O U T
        ...effects(omit(LayoutWatchers, ['loadFavorisOrderSaga', 'loadPartnersLayoutSaga', 'loadResellersLayoutSaga'])),
        // L A Y O U T

        // P A R T N E R S
        ...effects(PartnerWatchers),
        // P A R T N E R S

        // R E S E L L E R S
        ...effects(ResellerWatchers),
        // R E S E L L E R S

        // S E G M E N T S
        ...effects(SegmentWatchers),
        // S E G M E N T S

        // P R O D U C T   G R O U P S
        ...effects(ProductGroupWatchers),
        // P R O D U C T   G R O U P S

        // D I S C O U N T S
        ...effects(DiscountWatchers),
        // D I S C O U N T S

        // P R O M O T I O N S
        ...effects(PromotionWatchers),
        // P R O M O T I O N S

        // T R A N S L A T I O N S
        ...effects(TranslationWatchers),
        // T R A N S L A T I O N S

        // I M P O R T S
        ...effects(ImportWatchers),
        // I M P O R T S

        // C U S T O M E R S
        ...effects(omit(CustomerWatchers, ['loadShippingAddressesSaga', 'loadEditableCustomerSaga', 'loadCustomerTurnoverSaga'])),
        // C U S T O M E R S

        // O R D E R S
        ...effects(OrderWatchers),
        // O R D E R S

        // Q U O T E S
        ...effects(QuoteWatchers),
        // Q U O T E S

        // F O R M S
        ...effects(FormWatchers),
        // F O R M S

        // J O B   R E S U L T
        ...effects(omit(JobResultWatchers, ['printPaletteSaga'])),
        // J O B   R E S U L T

        // P A C K A G I N G
        ...effects(PackagingWatchers),
        // P A C K A G I N G

        // R O L L S   I N
        ...effects(RollsInWatchers),
        // R O L L S   I N

        // R O L L S   O U T
        ...effects(RollsOutWatchers),
        // R O L L S   O U T

        // F O R M   V E R S I O N S
        ...effects(FormVersionWatchers),
        // F O R M   V E R S I O N S

        // P L A N N I N G
        ...effects(PlanningWatchers),
        // P L A N N I N G

        // M A C H I N E S
        ...effects(MachineWatchers),
        // M A C H I N E S

        // J O B S
        ...effects(JobWatchers),
        // J O B S

        // C O A T I N G   I N
        ...effects(CoatingInWatchers),
        // C O A T I N G   I N

        // C O A T I N G   O U T
        ...effects(CoatingOutWatchers),
        // C O A T I N G   O U T

        // R E P R I N T
        ...effects(ReprintWatchers),
        // R E P R I N T

        // E R R O R S
        ...effects(ErrorsWatchers),
        // E R R O R S

        // O R D E R   I T E M
        ...effects(OrderItemWatchers),
        // O R D E R   I T E M

        // D E S I G N   L I B R A R Y
        ...effects(DesignLibraryWatchers),
        // D E S I G N   L I B R A R Y

        // L O G I S T I C
        ...effects(LogisticWatchers),
        // L O G I S T I C

        // B O X
        ...effects(BoxWatchers),
        // B O X

        // E M A I L   T E M P L A T E
        ...effects(EmailTemplateWatchers),
        // E M A I L   T E M P L A T E

        // S H I P P I N G   T Y P E
        ...effects(shippingTypeWatchers),
        // S H I P P I N G   T Y P E

        // P A Y M E N T   T Y P E
        ...effects(paymentTypeWatchers),
        // P A Y M E N T   T Y P E

        // S T O R E
        ...effects(storeWatchers),
        // S T O R E

        // A C C O U N T A N C Y
        ...effects(accountancyWatchers),
        // A C C O U N T A N C Y

        // S T A T I S T I C S
        ...effects(statisticsWatchers),
        // S T A T I S T I C S

    ]);
}
